<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.preStyle.selfStyle.border.type = ''"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.border.type == ''?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.border.type == ''?'#fff':'#000',border: selectdItem.preStyle.selfStyle.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.preStyle.selfStyle.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.preStyle.selfStyle.border.type == 'solid'?'#fff':'#000',border: selectdItem.preStyle.selfStyle.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.preStyle.selfStyle.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.preStyle.selfStyle.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.preStyle.selfStyle.border.color"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.preStyle.selfStyle.border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.preStyle.selfStyle.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;" v-if="selectdItem.preStyle.selfStyle.border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.preStyle.selfStyle.border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
							:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="display: flex;justify-content: center;cursor: pointer;width: 210px;margin-top: 15px;">
				<div style="background-color: #F6F7F9;width: 198px;display: flex;flex-direction: column;">
					<div style="display: flex;justify-content: space-between">
						<div style="margin: 6px;">
							容器背景
						</div>
						<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype"
							style="display: flex;align-items: center;margin-left:8px;">
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'color'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">纯色</span>
							</div>
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'gradient'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">渐变</span>
							</div>
							<div @click="selectdItem.preStyle.selfStyle.bg.bgtype = 'img'"
								:style="{backgroundColor:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'#8c62ff':'#fff',color:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'#fff':'#000',border:selectdItem.preStyle.selfStyle.bg.bgtype == 'img'?'solid 1px #8c62ff':'solid 1px #959595' }"
								style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
								<span style="scale: 0.85;">图片</span>
							</div>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;margin-top: 10px;width: 235px;font-size: 12px;">
						<div
							style="display: flex;align-items: center;background-color: #F6F7F9;height: 38px;width: 210px;justify-content: space-around;">
							<div style="font-size: 12px;">
								背景图片
							</div>
							<div @click="dialogVisible = true"
								style="height: 30px;width: 30px;background-color: #fff;display: flex;align-items: center;justify-content: center;">
								<el-image :src="selectdItem.preStyle.selfStyle.bg.img" style="cursor: pointer;">
									<div slot="error" class="image-slot">
										<i style="font-size: 16px;" class="el-icon-plus"></i>
									</div>
								</el-image>
							</div>
							<el-select size="mini" style="width: 82px;"
								v-model="selectdItem.preStyle.selfStyle.bg.type" filterable allow-create
								default-first-option placeholder="渲染方式">
								<el-option label="重复" value="repeat">
								</el-option>
								<el-option label="x轴重复" value="repeat-x">
								</el-option>
								<el-option label="y轴重复" value="repeat-y">
								</el-option>
								<el-option label="平铺" value="">
								</el-option>
								<el-option label="不平铺" value="no-repeat">
								</el-option>
							</el-select>
						</div>
					</div>
		
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;">
						<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
							<div style="width: 40px;">
								宽度:
							</div>
							<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
								:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
								:value="selectdItem.preStyle.selfStyle.bg.bgImgWidth"
								@change="(e)=>{selectdItem.preStyle.selfStyle.bg.bgImgWidth = e}"></wm-input-number>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;justify-content: center;">
						<div style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;">
							<div style="width: 40px;">
								高度:
							</div>
							<wm-input-number style="margin-left: 10px;" :iptWidth="80" :disabled="false"
								:styleObj="{width: '100px',height: '30px'}" :step="1" :min="1" :max="10000000000"
								:value="selectdItem.preStyle.selfStyle.bg.bgImgHeigth"
								@change="(e)=>{selectdItem.preStyle.selfStyle.bg.bgImgHeigth = e}"></wm-input-number>
						</div>
					</div>
		
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'img'"
						style="display: flex;align-items: center;margin-left: 10px;margin-top: 10px;">
						<div>
							背景位置
						</div>
		
						<el-select @change="(e)=>{selectdItem.preStyle.selfStyle.bg.position = e}"
							style="margin-left: 10px;width: 120px;"
							v-model="selectdItem.preStyle.selfStyle.bg.position" filterable allow-create
							default-first-option placeholder="图片位置">
							<el-option label="左上方" value="top left">
							</el-option>
							<el-option label="上中间" value="top center">
							</el-option>
							<el-option label="右上方" value="top right">
							</el-option>
							<el-option label="左中方" value="center left">
							</el-option>
							<el-option label="居中" value="center center">
							</el-option>
							<el-option label="右中方" value="center right">
							</el-option>
							<el-option label="下左方" value="bottom left">
							</el-option>
							<el-option label="下居中" value="bottom center">
							</el-option>
							<el-option label="下右方" value="bottom right">
							</el-option>
						</el-select>
					</div>
		
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype == 'gradient'"
						style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
						<div
							style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<div style="display: flex;flex-direction: column;">
								<div style="display: flex;align-items: center;">
								</div>
								<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
									placeholder="请输入内容" v-model="selectdItem.preStyle.selfStyle.bg.bgGradient">
								</el-input>
							</div>
							<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
								需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
									href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
									target="_blank" href="https://webgradients.com/">Gradient2</a>
							</div>
						</div>
					</div>
					<div v-if="selectdItem.preStyle.selfStyle.bg.bgtype && selectdItem.preStyle.selfStyle.bg.bgtype == 'color'"
						style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;font-size: 12px;">
						<div
							style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
							<div style="font-size: 12px;">
								背景纯色
							</div>
							<el-color-picker size="mini" @change="(e)=>{
								selectdItem.preStyle.selfStyle.bg.color = e
							}" style="height: 28px;width: 28px;margin-top: 4px;"
								v-model="selectdItem.preStyle.selfStyle.bg.color"></el-color-picker>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :modal="false" custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisible" width="80%"
			:before-close="()=>{dialogVisible = false}">
			<select-img style="height: 70vh" @confirmImg="confirmImg" v-if="dialogVisible"></select-img>
		</el-dialog>
	</div>
</template>

<script>
	import selectImg from '../components/selectImg.vue'
	import wmInputNumber from '../components/inputNumber.vue'

	export default {
		components: {
			selectImg,
			wmInputNumber
		},
		props: {
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				dialogVisible: false,
				paddingAll: true,
				borderContainerRadiusAll: true,
				borderContainerSizeAll: true
			}
		},
		mounted() {
			console.log('selectdItemselectdItem', this.selectdItem)
		},
		methods: {
			confirmImg(e) {
				this.dialogVisible = false
				this.selectdItem.preStyle.selfStyle.bg.img = e.url
				// console.log('confirmImg e', e)
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.preStyle.selfStyle.border.borderRadius = []
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderRadius.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.preStyle.selfStyle.border.borderSize = []
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
					this.selectdItem.preStyle.selfStyle.border.borderSize.push(e.target.value)
				}
			},
		}

	}
</script>

<style scoped lang="scss">
	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>